import $ from 'jquery';

(function ($) {
  $.fn.toggleDisabled = function (condition) {
    var disable = function disable(el, disabled) {
      return el.prop('disabled', disabled);
    };

    return this.each(function (index) {
      var $this = $(this);

      if (condition != null) {
        return disable($this, condition);
      } else {
        var currentState = $this.prop('disabled');
        return disable($this, !currentState);
      }
    });
  };
})($);